









import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import JavascriptAPI from '@/utils/JavascriptAPI'
import { providerLogo } from '@/utils/helpers'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  props: {
    // identifyFields: { type: Array, required: true },
    provider: { type: String, required: true }
  },
  components: {}
})
export default class IdentityWizard extends Vue {
  get getProviderLogo () {
    return providerLogo(this.$props.provider)
  }
}
